module.exports = __webpack_public_path__ + "operace-ocnich-vicek-dolni_3_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-ocnich-vicek-dolni_3_before.jpg
// module id = 1150
// module chunks = 0